import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import QueryString from 'query-string';
import { useLocation, useParams } from 'react-router';
import * as Yup from 'yup';

import { EventContext } from '../../../Contexts/EventContext';
import ErrorMessage from '../../../Shared/Components/ErrorMessage';
import Loading from '../../../Shared/Components/Loading';
import ModalCustom from '../../../Shared/Components/ModalCustom';
import { error, success } from '../../../Shared/Components/Toast';
import useApi from '../../../Shared/hooks/api/Index';
import { useAccess } from '../../../Shared/hooks/useAccess';
import Master from '../../Layouts/Master';

const validationSchema = Yup.object().shape({
  national_card_id: Yup.string()
    .required('کد ملی الزامی است')
    .min(10, 'کد ملی باید 10 رقم باشد')
    .max(10, 'کد ملی باید 10 رقم باشد'),
  post: Yup.number()
    .typeError('انتخاب سمت الزامی است')
    .required('انتخاب سمت الزامی است'),
  team: Yup.number().typeError().nullable(),
});

const RegisterPostAllowProvince = () => {
  const [tabActive, setTabActive] = useState(0);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const eventContext = useContext(EventContext);
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const { search } = useLocation();
  const [parseParams, setParseParams] = useState({});
  const [removeModal, setRemoveModal] = useState(false);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [removeId, setRemoveId] = useState(undefined);
  const { canManageMatches } = useAccess();

  useEffect(() => {
    getInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const getInfo = async () => {
    setLoading(true);
    const queryString = QueryString.parse(search);
    setParseParams(queryString);
    await useApi.get(
      `/panel/match/register-match-posts/${id}`,
      {},
      (res) => {
        const { data } = res.data;
        eventContext.allowProvinces = data?.allowed;
        eventContext.matchAges = data?.match_ages;
        eventContext.registers = data?.registered_staffs;
        eventContext.teams = data?.teams;
        eventContext.matchPosts = data?.match_posts;
        setLoading(false);
      },
      (err) => {
        error('خطا در دریافت اطلاعات');
        setLoading(false);
      },
    );
    setLoading(false);
  };
  const registerUser = async (
    values,
    setSubmiting,
    match,
    match_age,
    team = false,
  ) => {
    setFormSubmitLoading(true);
    const request = {};
    if (team) {
      request['code'] = values?.national_card_id;
      request['allowed'] = id;
      request['match'] = match;
      request['match_age'] = match_age;
      request['post'] = values['post'];
      request['team'] = values['team'];
    } else {
      request['code'] = values?.national_card_id;
      request['allowed'] = id;
      request['match'] = match;
      request['match_age'] = match_age;
      request['post'] = values['post'];
    }

    console.log(values);

    await useApi.post(
      '/panel/match/register-match-posts',
      request,
      (res) => {
        const { data } = res;
        if (data?.status === 422) {
          error(data?.message);
          setFormSubmitLoading(false);
          return;
        } else if (data?.status === 200) {
          success('کاربر با موفقیت اضافه شد');
          getInfo();
        }

        setFormSubmitLoading(false);
      },
      (err) => {
        console.log(err);
        error('عملیات با خطا مواجه شد');
        setFormSubmitLoading(false);
      },
    );
  };

  const removeRegisterUser = async (registerId) => {
    setRemoveLoading(true);
    await useApi.post(
      '/panel/match/remove-match-posts',
      { staff: registerId },
      (res) => {
        const { data } = res;
        if (data?.status === 422) {
          error(data?.message);
          setRemoveLoading(false);
          return;
        } else if (data?.status === 200) {
          success('کاربر با موفقیت حذف شد');
          setRemoveModal(false);
          getInfo();
        }
        setRemoveLoading(false);
      },
      (err) => {
        console.log(err);
        error('عملیات با خطا مواجه شد');
        setRemoveLoading(false);
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            ثبت نام شرکت کنندگان
          </h1>
        </div>
      </div>
      <div className='row'>
        {/* <div className='w-100 alert alert-primary bg-info text-center f-14 text-white m-2'>
          ظرفیت هر رده سنی 1 نفر
        </div> */}
        {parseParams?.team === 'true' ? (
          <>
            <div className='d-flex flex-row justify-content-start align-items-center m-2 border-bottom border-info w-100'>
              {eventContext.matchAges?.map((item, index) => (
                <div
                  onClick={() => setTabActive(index)}
                  className={`d-flex flex-row align-items-center btn ${
                    index === tabActive ? 'btn-info' : 'btn-outline-info'
                  } py-2 f-14 c-pointer mr-1`}
                  style={{
                    borderBottomRightRadius: '0px',
                    WebkitBorderBottomLeftRadius: '0px',
                  }}
                >
                  <span>رده سنی {item?.age?.title}</span>
                </div>
              ))}
            </div>
            {eventContext.matchAges?.map(
              (item, index) =>
                index === tabActive && (
                  <>
                    <div className='col-12'>
                      <table className='table table-hover'>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>نام</th>
                            <th>نام خانوادگی</th>
                            <th>سمت</th>
                            <th>کد ملی</th>
                            <th>همراه</th>
                            <th>تلفن</th>
                            {canManageMatches() && (
                              <th>حذف</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {eventContext.registers
                            ?.filter((r) => r?.match_age_id === item?.id)
                            ?.map((register, index) => (
                              <tr key={register.id}>
                                <th>{index + 1}</th>
                                <td>{register?.user?.name}</td>
                                <td>{register?.user?.last_name}</td>
                                <td>{register?.post?.title}</td>
                                <td>{register?.user?.national_card_id}</td>
                                <td>{register?.user?.mobile}</td>
                                <td>{register?.user?.phone ?? '-'}</td>
                                {canManageMatches() && (
                                  <td>
                                    <i
                                      onClick={() => {
                                        setRemoveId(register?.id);
                                        setRemoveModal(true);
                                      }}
                                      className='far fa-times border rounded-pill border-danger text-center d-flex flex-row align-items-center justify-content-center text-danger c-pointer'
                                      style={{ width: '17px', height: '17px' }}
                                    ></i>
                                  </td>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className='col-12'>
                      <Formik
                        initialValues={{
                          national_card_id: '',
                          post: '',
                          team: '',
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                          registerUser(
                            values,
                            setSubmitting,
                            item?.match_id,
                            item?.id,
                            true,
                          );
                        }}
                        validationSchema={validationSchema}
                      >
                        {({
                          values,
                          errors,
                          handleChange,
                          handleSubmit,
                          isSubmitting,
                          setFieldValue,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <hr className='bg-scondary' />
                            <div className='d-flex flex-row align-items-center my-3'>
                              <div className='form-group p-0 m-0 w-25'>
                                <select
                                  className='form-control'
                                  name='post'
                                  onChange={handleChange}
                                >
                                  <option>انتخاب سمت</option>
                                  {eventContext?.matchPosts?.map((post) => (
                                    <option value={post?.id}>
                                      {post?.post?.title}
                                    </option>
                                  ))}
                                </select>
                                <ErrorMessage
                                  error={errors?.post}
                                  classes='mb-3'
                                />
                              </div>
                              <div className='form-group p-0 m-0 w-25 mx-2'>
                                <select
                                  className='form-control'
                                  name='team'
                                  onChange={handleChange}
                                >
                                  <option>انتخاب تیم مربوطه</option>
                                  {eventContext?.teams
                                    ?.filter(
                                      (t) => t?.match_age?.id === item?.id,
                                    )
                                    ?.map((team) => (
                                      <option value={team?.id}>
                                        تیم {team?.index}{' '}
                                        {team?.match_age?.age?.title}
                                      </option>
                                    ))}
                                </select>
                                <ErrorMessage
                                  error={errors?.team}
                                  classes='mb-3'
                                />
                              </div>
                              <div className='form-group p-0 m-0 w-25 mx-2'>
                                <input
                                  className='form-control'
                                  placeholder='کد ملی'
                                  name='national_card_id'
                                  value={values?.national_card_id}
                                  onChange={handleChange}
                                />
                                <ErrorMessage
                                  error={errors?.national_card_id}
                                  classes='mb-3'
                                />
                              </div>
                              {canManageMatches() &&
                                (formSubmitLoading ? (
                                  <div
                                    className='spinner-border spinner-border-sm text-success mb-1 f-18 mx-3'
                                    role='status'
                                  ></div>
                                ) : (
                                  <button
                                    className='bg-none border border-success rounded-pill text-success d-flex flex-row justify-content-center align-items-center f-18 p-0 mx-3'
                                    style={{ width: '20px', height: '20px' }}
                                  >
                                    <i className='far fa-plus'></i>
                                  </button>
                                ))}
                            </div>
                          </form>
                        )}
                      </Formik>
                    </div>
                  </>
                ),
            )}
          </>
        ) : (
          <>
            <div className='d-flex flex-row justify-content-start align-items-center m-2 border-bottom border-info w-100'>
              {eventContext.matchAges?.map((item, index) => (
                <div
                  onClick={() => setTabActive(index)}
                  className={`d-flex flex-row align-items-center btn ${
                    index === tabActive ? 'btn-info' : 'btn-outline-info'
                  } py-2 f-14 c-pointer mr-1`}
                  style={{
                    borderBottomRightRadius: '0px',
                    WebkitBorderBottomLeftRadius: '0px',
                  }}
                >
                  <span>رده سنی {item?.age?.title}</span>
                </div>
              ))}
            </div>
            {eventContext.matchAges?.map(
              (item, index) =>
                index === tabActive && (
                  <>
                    <div className='col-12'>
                      <table className='table table-hover'>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>نام</th>
                            <th>نام خانوادگی</th>
                            <th>سمت</th>
                            <th>کد ملی</th>
                            <th>همراه</th>
                            <th>تلفن</th>
                            {canManageMatches() && (
                              <th>حذف</th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {eventContext.registers
                            ?.filter((r) => r?.match_age_id === item?.id)
                            ?.map((register, index) => (
                              <tr key={register.id}>
                                <th>{index + 1}</th>
                                <td>{register?.user?.name}</td>
                                <td>{register?.user?.last_name}</td>
                                <td>{register?.post?.title}</td>
                                <td>{register?.user?.national_card_id}</td>
                                <td>{register?.user?.mobile}</td>
                                <td>{register?.user?.phone ?? '-'}</td>
                                {canManageMatches() && (
                                  <td>
                                    <i
                                      onClick={() => {
                                        setRemoveId(register?.id);
                                        setRemoveModal(true);
                                      }}
                                      className='far fa-times border rounded-pill border-danger text-center d-flex flex-row align-items-center justify-content-center text-danger c-pointer'
                                      style={{ width: '17px', height: '17px' }}
                                    ></i>
                                  </td>
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className='col-12'>
                      <Formik
                        initialValues={{
                          national_card_id: '',
                          post: '',
                        }}
                        onSubmit={(values, { setSubmitting }) => {
                          registerUser(
                            values,
                            setSubmitting,
                            item?.match_id,
                            item?.id,
                            false,
                          );
                        }}
                        validationSchema={validationSchema}
                      >
                        {({
                          values,
                          errors,
                          handleChange,
                          handleSubmit,
                          isSubmitting,
                          setFieldValue,
                        }) => (
                          <form onSubmit={handleSubmit}>
                            <hr className='bg-scondary' />
                            <div className='d-flex flex-row align-items-center my-3'>
                              <div className='form-group p-0 m-0 w-25'>
                                <select
                                  className='form-control'
                                  name='post'
                                  onChange={handleChange}
                                >
                                  <option>انتخاب سمت</option>
                                  {eventContext?.matchPosts?.map((post) => (
                                    <option value={post?.id}>
                                      {post?.post?.title}
                                    </option>
                                  ))}
                                </select>
                                <ErrorMessage
                                  error={errors?.post}
                                  classes='mb-3'
                                />
                              </div>
                              <div className='form-group p-0 m-0 w-25 mx-2'>
                                <input
                                  className='form-control'
                                  placeholder='کد ملی'
                                  name='national_card_id'
                                  value={values?.national_card_id}
                                  onChange={handleChange}
                                />
                                <ErrorMessage
                                  error={errors?.national_card_id}
                                  classes='mb-3'
                                />
                              </div>
                              {canManageMatches() &&
                                (formSubmitLoading ? (
                                  <div
                                    className='spinner-border spinner-border-sm text-success mb-1 f-18 mx-3'
                                    role='status'
                                  ></div>
                                ) : (
                                  <button
                                    className='bg-none border border-success rounded-pill text-success d-flex flex-row justify-content-center align-items-center f-18 p-0 mx-3'
                                    style={{ width: '20px', height: '20px' }}
                                  >
                                    <i className='far fa-plus'></i>
                                  </button>
                                ))}
                            </div>
                          </form>
                        )}
                      </Formik>
                    </div>
                  </>
                ),
            )}
          </>
        )}
      </div>
      <ModalCustom modalIsOpen={removeModal}>
        <div className='d-flex flex-row justify-content-between align-items-center border-bottom pb-2'>
          <span className=''>حذف ثبت نام</span>
          <i
            className='far fa-times text-white f-20 mx-2 c-pointer'
            onClick={() => setRemoveModal(false)}
          ></i>
        </div>
        <div className='w-100 my-3'>
          <p className='text-center f-13 my-3 px-3'>
            آیا از حذف این ثبت‌نام مطمئن هستید؟ در صورت وجود پرداخت موفق، مبلغ
            پرداختی به کیف پول کاربر برمی‌گردد.
          </p>
          <div className='col-12 d-flex flex-row justify-content-center align-items-center'>
            <span
              className='btn px-5 btn-danger text-white f-12 my-3 mx-2 c-pointer'
              onClick={() => setRemoveModal(false)}
            >
              انصراف
            </span>
            {removeLoading ? (
              <button
                onClick={() => removeRegisterUser(removeId)}
                className='btn px-5 btn-info text-white f-12 my-3'
              >
                <div
                  class='spinner-border spinner-border-sm text-white'
                  role='status'
                ></div>
              </button>
            ) : (
              <button
                onClick={() => removeRegisterUser(removeId)}
                className='btn px-5 btn-info text-white f-12 my-3'
              >
                حذف
              </button>
            )}
          </div>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default RegisterPostAllowProvince;
